import styled from "styled-components";

const Contact = () => {
  

  return (
  <Wrapper>
    <h2 className="common-heading">Contact Page</h2>

    <iframe title="googlemap"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d701.
    1719286625815!2d72.82619190422317!3d19.
    066497933515397!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.
    1!3m3!1m2!1s0x3be7c96d127f30f1%3A0x3879f98b835b8ffc!2sRizvi%20
    Law%20College!5e0!3m2!1sen!2sin!4v1668863502100!5m2!1sen!2sin" 
    style={{border: 0, width:"100%" ,height:400, allowFullScreen:"", loading:"lazy"   }}

    referrerPolicy="no-referrer-when-downgrade"></iframe>

    <div className="container">
      <div className="contact-form">
        <form action="https://formspree.io/f/mzbwwdry" method="POST" className="contact-inputs">
          <input type="text" placeholder="username" name="username" required autoComplete="off"/>
          <input type="email" name="email" placeholder="Email" autoComplete="off" required />
          <textarea name="mesage" placeholder="Enter your message" cols="30" rows="10" required />
          <input type="Submit" />
        </form>
      </div>
    </div>
  </Wrapper>
  );
};

const Wrapper = styled.section`
    padding: 9rem 0 5rem 0;
    text-align: center;

    .container {
      margin-top: 6rem;

      .contact-form {
        max-width: 50rem;
        margin: auto;

        .contact-inputs {
          display: flex;
          flex-direction: column;
          gap: 3rem;

          input[type="submit"] {
            cursor: pointer;
            transition: all 0.2s;

            &:hover {
              background-color: ${({ theme }) => theme.colors.white};
              border: 1px solid ${({ theme }) => theme.colors.btn};
              color: ${({ theme }) => theme.colors.btn};
              transform: scale(0.9);
            }
          }
        }
      }
    }
  `;

export default Contact;
